<div class="bg-[#fff] border-t-0 border-r-0 border-b border-l-0 border-solid border-[#d5d7db] relative">
  <div class="flex min-h-[150px] items-center justify-center flex-col">
    <div class="text-[14px] leading-[18px]">{{ title() }}</div>
    <div class="text-[34px] leading-[54px]">{{ subTitle() }}</div>
  </div>
  <img
    class="absolute inset-[16px_16px_auto_auto] cursor-[pointer]"
    src="assets/svg/x-blue.svg"
    (click)="close.emit()"
  />
</div>
